import { useMutation } from '@tanstack/react-query';
import convertFromTrial from 'API/Company/convertFromTrial';
import { toast } from 'react-toastify';

const useConvertFromTrial = (companyId, currentScope) => {
    return useMutation({
        mutationFn: async () => {
            try {
                const result = await convertFromTrial(
                    companyId,
                    currentScope,
                ).then((res) => res);
                return result;
            } catch (error) {
                let errorMessage = `Failed to convert from trial: ${error || ''}`;
                if (error?.response?.data?.message) {
                    errorMessage = error.response.data.message;
                }
                console.error(errorMessage);
                toast.error(errorMessage);
                throw error;
            }
        },
        staleTime: 0,
    });
};

export default useConvertFromTrial;
